import React from 'react';

export default () => {
    return (
        <div>
            <h1>Profile</h1>
        </div>
    )
}